"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var formatKeys = {
  MY: 'i18n.dateTime.monthAndYear',
  MD: 'i18n.dateTime.monthAndDay'
};

var _default = function _default(_ref) {
  var value = _ref.value,
      type = _ref.type,
      format = _ref.format,
      length = _ref.length;

  var momentValue = _I18n.default.moment[type](value);

  var monthName = '';

  if (length === 's') {
    var monthKeys = Object.keys(_I18n.default.translations.en.i18n.dateTime.shortForm.months);
    var shortMonthKey = monthKeys[momentValue.month()];
    monthName = _I18n.default.text("i18n.dateTime.shortForm.months." + shortMonthKey, {
      locale: _I18n.default.locale
    });
  } else {
    monthName = momentValue.format('MMMM');
  }

  var options = {
    monthName: monthName,
    locale: _I18n.default.locale
  };

  if (format === 'MD') {
    options.dayNumber = momentValue.date();
  } else {
    options.yearNumber = momentValue.year().toString();
  }

  return _I18n.default.text(formatKeys[format], options);
};

exports.default = _default;
module.exports = exports.default;